import FloatingLabelInput from "./floatingLabelInput";
import FloatingLabelTextArea from "./floatingLabelTextArea";

const UtilityForm = ({
            // handleFormSubmit, 
            handleFormChange, 
            data, 
            handleBlur, 
            error, 
            title,
            handleFileDownload,
            handleFileDelete,
            handleFileChange,
            name
    }) => {

    return (
        <div className="mt-14">
            <h3 className="text-center text-xl mb-10">
                {title}
            </h3>
            <form>
                <div className="pb-12 space-y-12">
                    <div className="grid gap-x-4 gap-y-8 grid-cols-2">
                        <div className="sm:col-span-1">
                            <FloatingLabelInput 
                                    handleChange={handleFormChange} 
                                    handleBlur={handleBlur}
                                    value={data.companyName}
                                    error={error?.companyName}
                                    name="companyName" 
                                    id={`companyName-${name}`} 
                                    label="Name of Company" 
                                    required={true}
                                />
                        </div>
                        <div className="sm:col-span-1">
                            <FloatingLabelInput 
                                    handleChange={handleFormChange} 
                                    value={data.contactEmail} 
                                    error={error?.contactEmail}
                                    handleBlur={handleBlur}
                                    name="contactEmail" 
                                    id={`contactEmail-${name}`} 
                                    type="email" 
                                    label="Contact Email" 
                                />
                        </div>
                    </div>
                    <div className="mt-10 grid gap-x-4 gap-y-8 grid-cols-2">
                        <div className="sm:col-span-1">
                            <FloatingLabelInput 
                                    handleChange={handleFormChange} 
                                    value={data.contactNumber} 
                                    error={error?.contactNumber}
                                    handleBlur={handleBlur}
                                    name="contactNumber" 
                                    id={`contactNumber-${name}`} 
                                    type="tel"
                                    label="Contact Number" 
                                />
                        </div>
                        <div className="sm:col-span-1">
                            <FloatingLabelInput 
                                    handleChange={handleFormChange} 
                                    handleBlur={handleBlur}
                                    value={data.accountNumber} 
                                    // error={error.accountNumber}
                                    name="accountNumber" 
                                    id={`accountNumber-${name}`} 
                                    type="number" 
                                    label="Account Number" 
                                />
                        </div>
                    </div>
                    <div className="mt-10 grid gap-x-4 gap-y-8 grid-cols-1">
                        <div className="sm:col-span-1">
                            <FloatingLabelInput 
                                    handleChange={handleFormChange} 
                                    value={data.serviceName} 
                                    name="serviceName" 
                                    id={`serviceName-${name}`} 
                                    label="What name is this utility service or lease currently in?" 
                                />
                        </div>
                    </div>
                    <div className="mt-10 grid gap-x-4 gap-y-8 grid-cols-1">
                        <div className="sm:col-span-1">
                            <FloatingLabelTextArea 
                                    handleChange={handleFormChange} 
                                    value={data.notes} 
                                    // error={managerDetailsState.formErrors.rentAmount}
                                    name="notes" 
                                    id={`notes-${name}`} 
                                    label="Notes" 
                                    rows="6"
                                    // required={true}
                                />
                        </div>
                    </div>

                    {/* Optional Upload Docs */}
                    <div className="flex items-center justify-center">                            
                        {(data.attachment && data.attachment !== 'null') ? (
                            <div className="grid grid-cols-5 justify-between items-center gap-2 p-4 bg-gray-50 shadow-md rounded-lg mb-2">
                                    <p className="col-span-4 text-sm font-medium text-indigo-600 truncate">
                                        {data.attachment?.split("/").pop() || "File Upload Error"}
                                    </p>
                                    <div className="col-span-1 flex justify-end">
                                        <button
                                            onClick={handleFileDownload}
                                            className="text-sm  hover:bg-blue-300 text-blue-700 py-2 px-4 rounded"
                                        >
                                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-circle" viewBox="0 0 16 16">
                                                <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"/>
                                            </svg> */}
                                            <svg xmlns="http://www.w3.org/2000/svg" height="26" viewBox="0 0 24 24" width="26">
                                                <path d="M0 0h24v24H0z" fill="none"/>
                                                <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                                            </svg>
                                        </button>
                                        <button
                                            onClick={handleFileDelete}
                                            className="text-sm hover:bg-red-300 text-red-700 py-2 px-4 rounded"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                                            </svg>
                                        </button>
                                </div>
                            </div>
                        ) : 
                            <div className="flex items-center justify-center w-80"
                                    onDragOver={(e) => {e.preventDefault(); e.stopPropagation()}}
                                    onDragEnter={(e) => {e.preventDefault(); e.stopPropagation()}}
                                    onDragLeave={(e) => {e.preventDefault(); e.stopPropagation()}}
                                    onDrop={(e) => { e.preventDefault(); e.stopPropagation(); handleFileChange(e)}}
                                >
                                <label htmlFor={`dropzone-file-${name}`} className="flex flex-col items-center justify-center w-full  border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50  hover:bg-gray-100 ">
                                    <div className="flex flex-col items-center justify-center pt-5 pb-4">
                                        <svg className="w-8 h-8 mb-4 text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"/>
                                        </svg>
                                        <p className="mb-2 text-sm text-gray-500 "><span className="font-semibold">Click to upload an Agreement/Contract</span> </p>
                                        <p className="mb-2 text-sm text-gray-500 "><span className="font-semibold">or Statement</span> </p>
                                        <p className="mb-2 text-sm text-gray-500 ">or drag and drop</p>
                                        <p className="mt-2 text-sm text-gray-500 "><span className="font-semibold">(Optional)</span> </p>
                                        {/* <p className="text-xs text-gray-500 ">PDF Only</p> */}
                                    </div>
                                    <input name='attachment'
                                        id={`dropzone-file-${name}`} 
                                        type="file" 
                                        className="hidden" 
                                        onChange={handleFileChange} 
                                    />
                                </label>
                            </div> 
                        }
                    </div>
                    
                </div>
            </form>
        </div>
    )
}


export default UtilityForm;